import FixedHeader from './components/fixedHeader';
import OffCanvasNav from './components/offCanvasNav';
import SiteHeaderSearchToggle from './components/siteHeaderSearchToggle';
import LangSelect from './components/langSelect';
import HeroSlider from './components/heroSlider';
import CarouselBlock from './components/carouselBlock';
import PageHeaderMap from './components/pageHeaderMap';
import CardCollection from './components/cardCollection';
import FiftyFiftyBlock from './components/fiftyfiftyBlock';
import PromoCarousel from './components/promoCarousel';
import TaxonomyFilter from './components/taxonomyFilter';
import NavsAndTabs from './components/navsAndTabs';
import FactsBlock from './components/factsBlock';

import { initLightboxGallery } from './components/lightboxGallery';

document.addEventListener('DOMContentLoaded', () => {
	FixedHeader.init();
	OffCanvasNav.init();
	SiteHeaderSearchToggle.init();
	LangSelect.init();
	CarouselBlock.init();
	PageHeaderMap.init();
	CardCollection.init();
	FiftyFiftyBlock.init();
	PromoCarousel.init();
	TaxonomyFilter.init();
	NavsAndTabs.init();
	FactsBlock.init();

	// Only init HeroSlider after the first slider item has lazyloaded
	const firstImageSlide = document.querySelector('.m-pageHeaderSlideImage.swiper-slide:first-child');
	if (firstImageSlide) {
		const hasImage = firstImageSlide.querySelector('.m-pageHeaderSlideImage__media');
		if (hasImage) {
			firstImageSlide.addEventListener(
				'lazyloaded',
				() => {
					HeroSlider.init();
				},
				{ once: true }
			);
		} else {
			HeroSlider.init();
		}
	}

	// Init Photoswipe on native wordpress gallery
	if (document.querySelectorAll('.gallery').length) {
		initLightboxGallery('.gallery');
	}
	if (document.querySelectorAll('figure.wp-caption').length) {
		initLightboxGallery('figure.wp-caption');
	}

	// Remove Iframe and Video loader when ready
	document.addEventListener('lazyloaded', (e) => {
		const closestHasLoaderParent = e.target.closest('.has-loader');

		if (closestHasLoaderParent) {
			closestHasLoaderParent.classList.remove('has-loader');
		}
	});
});
